// Vanity tip URL — /t/:handle resolves to creator profile with donate auto-open
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";

export default function TipShortlink() {
  const { handle } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    api.get(`/u/handle/${handle}`)
      .then(({ data }) => nav(`/u/${data.id}?donate=1`, { replace: true }))
      .catch(() => nav("/explore", { replace: true }));
  }, [handle, nav]);
  return <div className="p-20 text-center text-white/40">Resolving @{handle}…</div>;
}
